import { IEvent } from '@swoft/core';

export class BoundedContextCreatedEvent implements IEvent {
  readonly type = 'BoundedContextCreated';
  readonly timestamp: Date;
  readonly aggregateId: string;
  readonly version: number;
  readonly correlationId?: string;

  constructor(
    public readonly contextId: string,
    public readonly domainId: string,
    public readonly contextName: string,
    public readonly contextType: 'core' | 'supporting' | 'generic',
    public readonly authSessionId: string,
    public readonly initiatedByPersonId: string,
    correlationId?: string,
    version: number = 1
  ) {
    this.aggregateId = contextId;
    this.version = version;
    this.timestamp = new Date();
    this.correlationId = correlationId;
  }
}